import React from 'react';
import { observer } from 'mobx-react';

import { ExpandableCard } from 'core/components/expandable-card';
import { useDiscounts } from 'offer/hooks/use-discounts';
import { Discount } from './discount';
import { Paperless } from './paperless';
import { Inventory } from './inventory';
import { ConnectedHomeDiscount } from './connected-home-discount';

const DiscountToComponent = {
  paperless_savings: Paperless,
  imagery_collection_savings: Inventory,
  connected_home_discount_savings: ConnectedHomeDiscount
};

const DiscountsCard = observer(() => {
  const discounts = useDiscounts();
  const activeDiscounts = discounts.filter(({ isActive }) => isActive).length;
  return (
    <ExpandableCard title="Discounts" badge={`${activeDiscounts} of ${discounts.length}`}>
      {discounts.map(({ label, isActive, amount, description, possibleSavings, id }, ix) => {
        const Component = DiscountToComponent[id] || Discount;
        return (
          <Component
            key={ix}
            label={label}
            amount={amount}
            possibleSavings={possibleSavings}
            description={description}
            isActive={isActive}
          />
        );
      })}
    </ExpandableCard>
  );
});

export default DiscountsCard;
